export const welcomeSteps = [
  {
    target: 'body',
    content: (
      <>
        <div>
          <div className="hc-ta-center hc-mb-sm hc-color-black">
            <h3 className="hc-mb-xs hc-color-black">What's New in ShipIQ</h3>
            <p className="hc-fs-sm hc-color-black">
              Explore the newest features designed to improve your shipping
              management experience!
            </p>
          </div>
        </div>
      </>
    ),
    placement: 'center',
    disableBeacon: true,
    styles: {
      options: {
        width: 500,
      },
    },
  },
]
